<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData, NodeType } from '../../types/flow-types';
	import { getFlowCardDefinition } from '../../core/card-engine/registry';

	export let id: string;
	export let type: NodeType = 'virtualComponentCondition';
	export let data: NodeData;
	export let selected = false;
	export let validated = true;
	export let errors: string[] = [];

	$: definition = getFlowCardDefinition(type, String(data.paletteKey || ''));
	$: summary = definition?.summary(data) || 'Configure virtual component';
	$: eventOnly = type === 'virtualComponentEvent';
</script>

<BaseConditionNode
	{id}
	{type}
	{data}
	{selected}
	{validated}
	{errors}
	hideFalseOutput={eventOnly}
	cardTitle={summary}
	nodeTypeLabel={eventOnly ? 'Virtual button event' : 'Virtual value condition'}
	{...$$restProps}
>
	<div class="virtual-summary">{summary}</div>
</BaseConditionNode>

<style>
	.virtual-summary {
		font-size: 0.8125rem;
		line-height: 1.4;
	}
</style>
